// extracted by mini-css-extract-plugin
export default {"pages":"BlogList_pages__JnIVE","leftArrow":"BlogList_leftArrow__9npgo","rightArrow":"BlogList_rightArrow__ePmoT","label":"BlogList_label__g0lB3"};